import merge from 'lodash/merge';
import groupBy from 'lodash/groupBy';
import { normalizeRelations, resolveRelations } from '../helpers';

const state = {
  allIds: [],
  byId: {},
  byDealId: {},
  filteredById: []
};

const getters = {
  find: (state, _, __, rootGetters) => id =>
    resolveRelations(state.byId[id], ['order_products'], rootGetters, {
      inCart: true
    }),
  list: (state, getters) => state.allIds.map(id => getters.find(id))
};

const actions = {
  addProducts: ({ commit, dispatch }, products) => {
    if (products.length && products[0]?.deal_id)
      commit('addPrizesByDealId', products);
    else {
      products.forEach(product => {
        commit('add', normalizeRelations(product, ['order_products']));
        dispatch(
          'cartOrderProducts/addOrderProducts',
          product.order_products || [],
          {
            root: true
          }
        );
      });
    }
  },
  setPrizesDealId: ({ commit }, deal) => {
    commit('setPrizesDealId', deal);
    commit(
      'points/setPoints',
      {
        current_points: deal.current_points,
        next_points_expiration: deal.next_points_expiration
      },
      { root: true }
    );
  }
};

const mutations = {
  add: (state, product) => {
    if (!state.allIds.includes(product.id)) {
      state.byId[product.id] = product;
      state.allIds.push(product.id);
    } else {
      const merged = merge(state.byId[product.id], product);
      state.byId[product.id] = merged;
    }
  },
  addPrizesByDealId: (state, products) =>
    (state.byDealId = groupBy(products, 'deal_id')),
  setPrizesDealId: (state, deal) =>
    (state.filteredById = state.byDealId[deal.id])
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
};
